import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionState } from 'src/app/enums/action-state.enum';
import { SubscriptionPlanRepo } from 'src/app/repositories/subscriptionPlan-repo';
import { ApplicationFeature } from 'src/swagger-gen/web-secured/models';
import { DataAfterCloseSubscriptionPlanDetailModal } from './models/dataAfterCloseSubscriptionPlanDetailModal';

@Component({
    selector: 'app-modal-badges',
    templateUrl: './modal-subscription-plan-detail.component.html',
    styleUrls: ['./modal-subscription-plan-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalSubscriptionPlanDetailComponent implements OnInit {

  FEATURE = ApplicationFeature;

  // downloadFile
  backendResponseDownloadedFile: any = null;
  // uploadFile
  backendResponseUploadedFile: any = null;

  // modalV : ModalVehiclesComponent

  public data: DataAfterCloseSubscriptionPlanDetailModal;
  public calledByOtherComponent = true;


  constructor(
    private subscriptionPlanRepo: SubscriptionPlanRepo,
    @Inject(MAT_DIALOG_DATA) public uid: string) {
  }

  ngOnInit(): void {
    this.data = new DataAfterCloseSubscriptionPlanDetailModal();
    this.data.subscriptionPlanUid = this.uid;
  }


  onUserWantsDownloadEvent(event: boolean): void {
    if (event) {
      this.downloadFile();
    }
  }

  onUserWantsUploadEvent(file: any): void {
    if (file) {
      this.uploadFile(file);
    }
  }



  downloadFile(): void {
    this.subscriptionPlanRepo.exportUniqueSubscriptionPlanDefinition(this.data.subscriptionPlanUid).toPromise()
    .then((response) => {
      this.backendResponseDownloadedFile = response;
    })
    .catch((err) => {
      this.backendResponseDownloadedFile = err;
    });
  }

  uploadFile(file: any): void {
    this.data.uploadFileState = ActionState.LOADING;
    this.subscriptionPlanRepo.importUniqueSubscriptionPlanDefinition(this.data.subscriptionPlanUid, file).toPromise()
    .then((response) => {
      this.backendResponseUploadedFile = response;
      this.data.uploadFileState = ActionState.SUCCESS;
    })
    .catch((err) => {
      this.backendResponseUploadedFile = err;
      this.data.uploadFileState = ActionState.FAILED;
    });
  }


}
